import {createSelector} from 'reselect';

import {AppParametricSelector} from '../../../helpers/reselectHelpers';
import {getPanels} from '../panelsSelectors';
import {panelIsAccountDetailsPanel} from '../panelsState';
import {ContactOrAccountDetailsPanelId} from '../panelStateBase';

export function makeGetAccountDetailsPanel<P>(
  getPanelId: AppParametricSelector<P, ContactOrAccountDetailsPanelId>,
) {
  return createSelector([getPanels, getPanelId], (panels, panelId) => {
    const panel = panels[panelId];
    if (!panel || !panelIsAccountDetailsPanel(panel)) {
      return null;
    }

    return panel;
  });
}
